module.exports = __webpack_public_path__ + "img/Solutions-Catalog-1110x450.75a2a392.png";